import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { translate, TranslocoService } from '@jsverse/transloco';
import { ClipboardService } from 'ngx-clipboard';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-warning-dialog',
    templateUrl: './warning-dialog.component.html',
    styleUrls: ['./warning-dialog.component.scss'],
    standalone: false
})
export class WarningDialogComponent implements OnInit {
  title: string;
  descriptionArray: any;
  defaultLinkTitle: string = translate('ERROR_DIALOG.VIEW_MORE');
  defaultLinkTitleLess: string = translate('ERROR_DIALOG.VIEW_LESS');
  copy: boolean;
  copyData: any;
  copyErrorText: any;
  viewMore = false;
  cancelButton = false;
 

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private clipboardApi: ClipboardService,
  public matdialogRef: MatDialogRef<WarningDialogComponent>,
  private sideNav: SidenavService, private authService: AuthService, private translocoService: TranslocoService) {
    this.title = data.title;
    this.cancelButton = data.cancelButton;
    if(data.description?.length > 0) {
      this.descriptionArray = [];
      for (const errorMessage of data.description){
        this.descriptionArray.push(errorMessage);
      }
    }
  }

  ngOnInit(): void {
    this.copy = false;
  }

  // to copy the warnings once copy clicked
  copyText(data): void {
    this.copyData = [];
    if (data.length > 0) {
      this.copyData = data.join(', ');
    } else {
      this.copyData = data;
    }
    this.copy = true;
    this.clipboardApi.copyFromContent(this.copyData);
    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  // to close popup on proceed click
  continue(): void {
    this.matdialogRef.close(true);
  }

  // to handle view more/view less click
  viewClick(): void {
    this.defaultLinkTitle =
      this.defaultLinkTitle ===
       translate('ERROR_DIALOG.VIEW_LESS') ? translate('ERROR_DIALOG.VIEW_MORE') : translate('ERROR_DIALOG.VIEW_LESS');
    this.viewMore = !this.viewMore;
  }
}
